import { createSelector } from '@reduxjs/toolkit';

import type { AppState } from '../types';
import type { Options } from './types';

export const getCfdOptions = (state: AppState): Options => state.cfd.options;

export const getCfdConnected = (state: AppState): boolean => state.cfd.isBrowserCFDConnected;

export const selectCountryCode = createSelector(
  [getCfdOptions],
  cfdOptions => cfdOptions.countryCode,
);
